import React, { useMemo } from 'react'
import useDispatch from '~editor/hooks/useDispatch'
import {
  AnyActionType,
  ActionTypes,
  MouseButtonAction,
  MouseButtons,
  getActionTypeLabel,
  IActionComponentProps,
} from '~core/forge.type'
import { Text, Box, SimpleGrid } from '@chakra-ui/react'
import { Select } from '~editor/components/Select'

interface IProps extends IActionComponentProps {
  action: MouseButtonAction
}

const MouseButtonsOptions = Object.keys(MouseButtons).map((value) => ({
  value,
  label: value,
}))

const ActionTypesOptions = MouseButtonAction.getAllowedTypes().map(
  (actionType) => ({
    label: getActionTypeLabel(actionType),
    value: actionType,
  }),
)

export const MouseButtonActionComponent = ({
  action,
  actions,
  activeActionGesture,
  isDisabled,
}: IProps) => {
  const dispatch = useDispatch()
  const selectedMouseButtonOption = useMemo(() => {
    return MouseButtonsOptions.find((option) => option.value === action.key)
  }, [action, action.key])
  const selectedActionTypeOption = useMemo(() => {
    return ActionTypesOptions.find((option) => option.value === action.type)
  }, [action, action.type])

  return (
    <SimpleGrid
      flex="1"
      templateColumns="1fr auto auto"
      alignItems="center"
      gap="12px"
    >
      <Box display="flex" flex="1" alignItems="center">
        <Select
          width="130px"
          height="32px"
          options={MouseButtonsOptions}
          defaultValue={MouseButtonsOptions[0]}
          isSearchable={false}
          isDisabled={isDisabled}
          value={selectedMouseButtonOption}
          onChange={(option) => {
            if (!option) return

            const value: MouseButtons = (option as any).value

            dispatch.nodes.updateActions({
              actionGestureType: activeActionGesture,
              actions: actions.map((_a: AnyActionType) => {
                const _action = { ..._a } as MouseButtonAction

                if (action.id === _action.id) {
                  _action.key = value
                }

                return _action
              }),
            })
          }}
        />
      </Box>
      <Text color="ui.text.grey" fontWeight="700">
        {'|'}
      </Text>
      <Select
        width="130px"
        height="32px"
        options={ActionTypesOptions}
        defaultValue={ActionTypesOptions[0]}
        isSearchable={false}
        isDisabled={isDisabled}
        value={selectedActionTypeOption}
        onChange={(option) => {
          if (!option) return

          const value: ActionTypes = (option as any).value

          dispatch.nodes.updateActions({
            actionGestureType: activeActionGesture,
            actions: actions.map((_a: AnyActionType) => {
              const _action = { ..._a }

              if (action.id === _action.id) {
                _action.type = value
              }

              return _action
            }),
          })
        }}
      />
    </SimpleGrid>
  )
}

export default MouseButtonActionComponent
